import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, of, Subscription } from 'rxjs';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LinkComponent implements OnInit, AfterViewChecked, OnDestroy {
  deviceInfo: any = null;
  data$: Observable<any> = this.component.data$;
  styleClass: string;
  hasEditPreferenceDiscountBtns: boolean;
  componentDataSub$: Subscription;
  componentData$: any;

  constructor(
    public component: CmsComponentData<CmsLinkComponent>,
    private deviceService: DeviceDetectorService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.componentDataSub$ = this.data$.subscribe((data) => {
      if (data !== null) {
        this.componentData$ = of(data);
        const updateStyleClass = data.styleClass;
        if (this.deviceInfo.browser.toLowerCase() === 'chrome') {
          if (typeof updateStyleClass !== 'undefined') {
            if (updateStyleClass.includes('primary-btn-safari')) {
              this.styleClass = 'button primary-btn';
            } else if (updateStyleClass.includes('secondary-btn-safari')) {
              this.styleClass = 'button secondary-btn';
            } else {
              this.styleClass = data.styleClass;
            }
          }
        } else {
          this.styleClass = data.styleClass;
        }
        this.cdr.detectChanges();
      }
    });
  }

  ngAfterViewChecked() {
    const hasEditPreference = document.querySelector('.myaccount-edit-preferences');
    const hasDiscount = document.querySelector('.myaccount-discounts');
    this.hasEditPreferenceDiscountBtns = hasEditPreference === null && hasDiscount === null ? false : true;
    if (this.hasEditPreferenceDiscountBtns) {
      if (hasEditPreference === null) {
        if (hasDiscount !== null) {
          hasDiscount.classList.add('right');
        }
      } else {
        if (hasDiscount !== null) {
          hasDiscount.classList.remove('right');
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.componentDataSub$) {
      this.componentDataSub$.unsubscribe();
    }
  }
}
